import rootJson from '../root/root.json';

export const isMobile = () => {
  let check = false;
  (function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge|maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a,
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4),
      )
    ) {
      check = true;
    }
  })(navigator.userAgent || navigator.vendor);
  return check;
};
export function stateUtils(state) {
  async function getNextJourney(currentJourney) {
    const journeys = rootJson.map(e => {
      return e.value;
    });
    if (journeys.length > 0) {
      const index = journeys.indexOf(currentJourney);
      const breadCrumbsLength = state.breadCrumbState.length;
      let newBreadCrumbs = [];
      let lastJourneyBreadcrumbUpdated = false;

      if (index > -1) {
        if (index === journeys.length - 1) {
          return currentJourney;
        } else {
          state.breadCrumbState.map((item: any, index: number) => {
            if (item.name === currentJourney && index !== breadCrumbsLength - 2) {
              newBreadCrumbs = [...newBreadCrumbs, { ...item, enabled: true }];
            } else if (item.name === currentJourney && index === breadCrumbsLength - 2) {
              newBreadCrumbs = [...newBreadCrumbs, { ...item, enabled: true }, { ...state.breadCrumbState[breadCrumbsLength - 1], enabled: true }];
              lastJourneyBreadcrumbUpdated = true;
            } else if (item.name !== currentJourney && !lastJourneyBreadcrumbUpdated) {
              newBreadCrumbs = [...newBreadCrumbs, item];
            }
          });
          state.breadCrumbState = [...newBreadCrumbs];
          state.currentJourney = journeys[index + 1];
          return journeys[index + 1];
        }
      } else {
        return journeys[0];
      }
    }
    return null;
  }
  async function getPrevJourney(currentJourney) {
    const journeys = rootJson.map(e => {
      return e.value;
    });
    if (journeys.length > 0) {
      const index = journeys.indexOf(currentJourney);
      if (index > -1) {
        if (index === 0) {
          return currentJourney;
        } else {
          state.currentJourney = journeys[index - 1];
          return journeys[index - 1];
        }
      } else {
        return journeys[0];
      }
    }
    return null;
  }
  async function setUserProfile(userProfile) {
    state.userProfile = { ...state.userProfile, ...userProfile };
  }
  async function getUserProfile() {
    return state.userProfile;
  }
  async function getBreadCrumbState() {
    return state.breadCrumbState;
  }
  async function updateBreadCrumbState(data) {
    state.breadCrumbState = [...data];
  }
  async function getQuizState() {
    return {
      currentIntroIndex: state.currentIntroIndex,
      currentQuizIndex: state.currentQuizIndex,
      quizData: state.quizData,
      showIntro: state.showIntro,
      showQuiz: state.showQuiz,
      selectedOptions: state.selectedOptions,
      quizPlainIndex: state.quizPlainIndex,
      quizFormattedData: state.quizFormattedData,
      defaultQuizData: state.defaultQuizData,
      selectedOptionsWithId: state.selectedOptionsWithId,
    };
  }
  async function updateQuizPayload(data) {
    state.quizPayload = [...data];
  }
  async function getVtoState() {
    return {
      showResultPage: state.showResultPage,
      keepPhoto: state.keepPhoto,
      recommendedStyles: state.recommendedStyles,
    };
  }
  async function updateQuizCountersAndShowStates(currentIntroIndex, currentQuizIndex, showIntro, showQuiz, quizPlainIndex) {
    state.currentIntroIndex = currentIntroIndex;
    state.currentQuizIndex = currentQuizIndex;
    state.showIntro = showIntro;
    state.showQuiz = showQuiz;
    state.quizPlainIndex = quizPlainIndex;
  }

  async function updateQuizData(quizData) {
    state.quizData = quizData;
  }
  async function updateQuizFormattedData(data) {
    state.quizFormattedData = data;
  }
  async function getQuizAnalysisResultsFromState() {
    return state.quizFormattedData;
  }
  async function getQuizPayload() {
    return state.quizPayload;
  }
  async function initState() {
    state.journey = 'quiz';
    state.currentJourney = await getNextJourney('');
    state.currentIntroIndex = 0;
    state.currentQuizIndex = 0;
    state.showIntro = true;
    state.showQuiz = false;
    state.quizPlainIndex = 0;
    state.breadCrumbState = [];
    state.RecommendedProducts = [];
    state.RecommendedArticles = [];
    state.userName = '';
    state.gender = '';
    state.newsletterSkipStatus = true;
    state.style = {
      activeTab: '',
      selectedStyleId: '',
      trackstyles: [],
      selectedStyleTab: '',
    };
    state.skinAnalysisResultsForML = [];
    state.getStyleData = { foundId: '', index: '', id: '' };
    state.keepPhoto = { enabled: false };
    state.showResultPage = false;
    state.showResultScreen = false;
    state.hideVTO = true;
    state.recommendedStyles = [];
    state.defaultQuizData = {};
    state.showErrorScreen = false;
  }
  async function updateRecommendedProducts(data) {
    state.RecommendedProducts = data;
  }
  async function updateQuizOptionSelectedWithId(questionId, selectedQuiz) {
    if (selectedQuiz) {
      state.selectedOptionsWithId = { ...state.selectedOptionsWithId, [questionId + '']: [...selectedQuiz] };
    } else {
      delete state.selectedOptionsWithId[questionId];
    }
  }
  async function removeQuizOptionSelectedWithId(questionId) {
    const newObj = { ...state.selectedOptionsWithId };
    delete newObj[questionId];
    state.selectedOptionsWithId = { ...newObj };
  }

  async function updateQuizOptionSelected(currentQuizIndex, selectedQuiz) {
    state.selectedOptions = { ...state.selectedOptions, [currentQuizIndex]: [...selectedQuiz] };
  }

  async function removeQuizOptionSelected(questionIndex) {
    const newObj = { ...state.selectedOptions };
    delete newObj[questionIndex];
    state.selectedOptions = { ...newObj };
    //delete state.selectedOptions[questionIndex];
  }

  async function updateRecommendedArticles(data) {
    state.RecommendedArticles = data;
  }
  async function updateUserName(data) {
    state.userName = data;
  }
  async function getUserName() {
    return state.userName;
  }
  function updateGender(data) {
    state.gender = data;
  }
  function getGender() {
    return state.gender;
  }
  async function getRecommendedProductsFromState(data) {
    console.info(data, 'data');
    return state.RecommendedProducts;
  }
  async function getRecommendedArticlesFromState(data) {
    console.info(data, 'data');
    return state.RecommendedArticles;
  }
  async function getQuizOptionSelected() {
    return state.selectedOptions;
  }
  async function geti18nData() {
    return state.i18nData;
  }
  async function getShowResultPage() {
    return state.showResultPage;
  }
  async function getKeepPhoto() {
    return state.keepPhoto;
  }
  async function getRecommendedStyles() {
    return state.recommendedStyles;
  }
  async function getStyle() {
    return state.style;
  }
  async function seti18nData(data) {
    state.i18nData = { ...data };
  }
  async function setConfig(data) {
    state.config = { ...data };
  }
  async function getConfig() {
    return state.config.default;
  }
  async function getRecommendedProducts(data) {
    console.info(data, 'data');
    return state.RecommendedProducts;
  }
  async function setRecommendedProducts(data) {
    state.RecommendedProducts = data;
  }
  async function setShowResultPage(data) {
    state.showResultPage = data;
  }
  async function setShowResultScreen(data) {
    state.showResultScreen = data;
  }
  async function setHideVTOScreen(data) {
    state.hideVTO = data;
  }
  async function getHideVTOScreen() {
    return state.hideVTO;
  }
  async function getShowResultScreen() {
    return state.showResultScreen;
  }
  async function getStateRetakeJourney() {
    return state.retakeJourney;
  }
  async function setStateRetakeJourney(data) {
    return (state.retakeJourney = data);
  }
  async function setRecommendedStyles(data) {
    state.recommendedStyles = data;
  }
  async function getDefaultQuizData() {
    return state.defaultQuizData;
  }
  async function setDefaultQuizData(data) {
    state.defaultQuizData = { ...data };
  }
  async function updateAllQuizOptionSelected(selectedQuiz) {
    state.selectedOptionsWithId = { ...selectedQuiz };
  }
  async function setKeepPhoto(data) {
    state.keepPhoto = data;
  }
  async function setAtUserJourney(data) {
    state.atUserJourney = data;
  }
  async function setStyle(data) {
    state.style = data;
  }
  async function setStyleData(data) {
    state.getStyleData = data;
  }
  async function getStyleData() {
    return state.getStyleData;
  }
  async function setNewsletterSkipStatus(data) {
    state.newsletterSkipStatus = data;
  }
  async function getNewsletterSkipStatus() {
    return state.newsletterSkipStatus;
  }

  async function setFlagSkipSelfieJourney(data) {
    if (data) {
      state.breadCrumbState = state.breadCrumbState.map(item => (item.name === 'selfie_screen' ? { ...item, enabled: false } : item));
    }
    state.skipSelfieJourney = data;
  }

  async function getFlagSkipSelfieJourney() {
    return state.skipSelfieJourney;
  }
  async function getUTMsPresent() {
    return state.UTMsPresent;
  }
  async function setUTMsPresent(data) {
    state.UTMsPresent = data;
  }

  async function getSelfieAnalysisResultsForML(category) {
    return state[`${category}AnalysisResultsForML`];
  }

  async function setShowErrorScreen(data) {
     state.showErrorScreen = data;
  }

  async function getShowErrorScreen() {
    return state.showErrorScreen
 }

  return {
    setShowErrorScreen,
    getShowErrorScreen,
    setStyleData,
    getStyleData,
    setHideVTOScreen,
    getHideVTOScreen,
    setNewsletterSkipStatus,
    getNewsletterSkipStatus,
    getNextJourney,
    getQuizState,
    initState,
    updateQuizCountersAndShowStates,
    updateQuizData,
    updateQuizOptionSelected,
    getPrevJourney,
    getBreadCrumbState,
    updateBreadCrumbState,
    updateQuizFormattedData,
    updateQuizPayload,
    getQuizPayload,
    updateRecommendedProducts,
    updateRecommendedArticles,
    getRecommendedProductsFromState,
    getRecommendedArticlesFromState,
    updateUserName,
    getUserName,
    geti18nData,
    seti18nData,
    setConfig,
    getConfig,
    getQuizAnalysisResultsFromState,
    updateGender,
    getGender,
    getQuizOptionSelected,
    setUserProfile,
    getUserProfile,
    setRecommendedProducts,
    getRecommendedProducts,
    setShowResultPage,
    getShowResultPage,
    setShowResultScreen,
    setRecommendedStyles,
    setKeepPhoto,
    setAtUserJourney,
    getRecommendedStyles,
    getKeepPhoto,
    getShowResultScreen,
    setStyle,
    getStyle,
    getVtoState,
    getDefaultQuizData,
    setDefaultQuizData,
    updateQuizOptionSelectedWithId,
    updateAllQuizOptionSelected,
    getStateRetakeJourney,
    setStateRetakeJourney,
    setFlagSkipSelfieJourney,
    getFlagSkipSelfieJourney,
    getSelfieAnalysisResultsForML,
    removeQuizOptionSelectedWithId,
    removeQuizOptionSelected,
    getUTMsPresent,
    setUTMsPresent,
  };
}
